import { render, staticRenderFns } from "./PartnerRegistration.vue?vue&type=template&id=5a35a8c1&"
import script from "./PartnerRegistration.vue?vue&type=script&lang=js&"
export * from "./PartnerRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a35a8c1')) {
      api.createRecord('5a35a8c1', component.options)
    } else {
      api.reload('5a35a8c1', component.options)
    }
    module.hot.accept("./PartnerRegistration.vue?vue&type=template&id=5a35a8c1&", function () {
      api.rerender('5a35a8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/PartnerRegistration.vue"
export default component.exports